// extracted by mini-css-extract-plugin
export default {"tab":"PositionTabs_tab__0p-hX"};